import CombineComponents from 'Widgets/CombineComponents/CombineComponents';
import { AutoScaleProvider } from './AutoScaleContext';
import CardsDisplayOptionsContextProvider from './CardsDisplayOptionsContext';
import CardsLayoutContextProvider from './CardsLayoutContext';
import CustomTagsProvider from './CustomTagsContext';
import HeatMapScaleTypeContextProvider from './HeatMapScaleContext';
import TagsPanelSortingProvider from './TagsPanelSortingContext';
import TagsPanelViewProvider from './TagsPanelViewContext';
const providers = [
    HeatMapScaleTypeContextProvider,
    CardsDisplayOptionsContextProvider,
    CardsLayoutContextProvider,
    TagsPanelViewProvider,
    CustomTagsProvider,
    TagsPanelSortingProvider,
    AutoScaleProvider
];
const TagsPanelControlsContextProvider = CombineComponents(providers);
export default TagsPanelControlsContextProvider;
